import { useEffect, useMemo, useState } from 'react';

const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024
};

export const useResponsive = () => {
  // Función para obtener el tamaño inicial
  const getSize = () => ({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0
  });

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    // Evitar ejecución en SSR
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      setWindowSize(getSize());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Memoizar los valores calculados
  const responsive = useMemo(
    () => ({
      isMobile: windowSize.width < BREAKPOINTS.mobile,
      isTablet: windowSize.width >= BREAKPOINTS.mobile && windowSize.width < BREAKPOINTS.tablet,
      isDesktop: windowSize.width >= BREAKPOINTS.tablet,
      width: windowSize.width,
      height: windowSize.height
    }),
    [windowSize.width, windowSize.height]
  );

  return responsive;
};
